import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Message from '../../../../../../common/Message';
import { messageCancellationStatusAlert } from '../../../../../../../constants/Messages';
import { useCancellationStatusStyles } from './styles';

const CancellationStatus = ({ ...props }) => {
  const { mobile } = props;

  const classes = useCancellationStatusStyles({ mobile });

  return (
    <>
      <Box className={classes.container}>
        <Message
          severity="info"
          message={messageCancellationStatusAlert}
          fullRounded
        />
      </Box>
    </>
  );
};

CancellationStatus.propTypes = {
  mobile: PropTypes.bool,
};

export default CancellationStatus;
